"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function ComprehensiveBrandingMarketingSolutions() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [cardVisible, setCardVisible] = useState(false);
  const [backgroundType, setBackgroundType] = useState<'video' | 'image' | 'color'>('video');
  const [backgroundValue, setBackgroundValue] = useState('/img/hero_kinetic_brushstrokes_orange.mp4');
  useEffect(() => {
    setCardVisible(true);
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.3;
  const cardOpacity = Math.max(0, 1 - scrollY / 400);
  return <section className="relative h-screen w-full overflow-hidden bg-background">
      {}
      {backgroundType === 'video' && <div className="absolute inset-0 -z-10" style={{
      transform: `translateY(${parallaxOffset}px)`,
      transition: "transform 0.1s ease-out"
    }}>
          <video ref={videoRef} autoPlay loop muted playsInline className="h-full w-full object-cover" aria-label="Abstract kinetic brushstrokes animation">
            <source src={backgroundValue} type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-primary/40" />
        </div>}

      {backgroundType === 'image' && <div className="absolute inset-0 -z-10" style={{
      transform: `translateY(${parallaxOffset}px)`,
      transition: "transform 0.1s ease-out"
    }}>
          <div className="h-full w-full bg-cover bg-center" style={{
        backgroundImage: `url(${backgroundValue})`
      }} />
          <div className="absolute inset-0 bg-primary/40" />
        </div>}

      {backgroundType === 'color' && <div className="absolute inset-0 -z-10" style={{
      backgroundColor: backgroundValue
    }} />}

      {}
      <div className="relative z-10 flex h-full items-center justify-center px-4 bg-background/60 backdrop-blur-sm">
        <Card ref={cardRef} className={`
            glass-effect
            max-w-2xl
            rounded-[var(--radius-xl)]
            px-8
            py-12
            text-center
            shadow-[0_8px_32px_rgba(0,0,0,0.16),0_0_24px_rgba(255,215,0,0.3)]
            transition-all
            duration-[var(--duration-slow)]
            ease-[var(--ease-out-back)]
            hover:shadow-[0_12px_48px_rgb(0_0_0_/_0.24),0_6px_16px_rgb(0_0_0_/_0.12),0_0_32px_rgba(255,215,0,0.4)]
            hover:-translate-y-1
            hover:ring-2
            hover:ring-accent/40
            ${cardVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}
          `} style={{
        opacity: cardOpacity
      }}>
          <h1 className="
              font-display
              text-4xl
              font-bold
              leading-tight
              text-foreground
              sm:text-5xl
              md:text-6xl
              mb-4
              animate-fade-in-up
            ">
            Comprehensive Branding & Marketing Solutions
          </h1>

          <p className="
              text-lg
              text-muted-foreground
              sm:text-xl
              mb-8
              animate-fade-in-up-delay-100
            ">
            Elevate your brand with our full suite of creative and strategic services designed to drive growth and engagement.
          </p>

          <Link to="/ServicesPage">
            <Button size="lg" className="
                btn-primary
                group
                relative
                overflow-hidden
                animate-fade-in-up-delay-200
              ">
              Explore Our Services
              <span className="
                  absolute
                  bottom-0
                  left-0
                  h-0.5
                  w-0
                  bg-foreground-accent
                  transition-all
                  duration-[var(--duration-medium)]
                  ease-[var(--ease-spring)]
                  group-hover:w-full
                " />
            </Button>
          </Link>
        </Card>
      </div>
    </section>;
}